"use client";

import React from "react";
import { Download, X, Smartphone, Zap, Bell, WifiOff } from "lucide-react";

type Props = {
  onInstall?: () => void;
  onDismiss?: () => void;
};

const InstallPrompt: React.FC<Props> = ({ onInstall, onDismiss }) => {
  return (
    <div className="fixed inset-x-0 bottom-0 z-[150] p-4 sm:bottom-6 sm:left-auto sm:right-6 sm:p-0">
      <div className="mx-auto w-full max-w-sm overflow-hidden rounded-2xl border border-grayScale-200 bg-white shadow-2xl shadow-primary-main/10 dark:border-grayScale-700 dark:bg-grayScale-800 sm:mx-0">
        {/* gradient header */}
        <div className="relative overflow-hidden bg-gradient-to-l from-primary-main via-primary-400 to-primary-300 px-5 py-4">
          <div className="pointer-events-none absolute -left-6 -top-6 h-24 w-24 rounded-full bg-white/15 blur-xl" />
          <div className="pointer-events-none absolute -bottom-8 right-4 h-20 w-20 rounded-full bg-white/10 blur-lg" />
          <div className="relative flex items-start justify-between">
            <div className="flex items-center gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/20 ring-2 ring-white/30 backdrop-blur-md">
                <Smartphone size={22} className="text-white" />
              </div>
              <div className="text-right">
                <p className="text-sm font-black text-white">نصب ترندی اسمارت</p>
                <p className="text-[11px] text-white/80">تجربه‌ای سریع‌تر و حرفه‌ای‌تر</p>
              </div>
            </div>
            <button
              onClick={onDismiss}
              className="flex h-7 w-7 items-center justify-center rounded-lg text-white/80 transition-colors hover:bg-white/15"
            >
              <X size={14} />
            </button>
          </div>
        </div>

        {/* body */}
        <div className="p-5">
          <p className="text-xs leading-6 text-grayScale-600 dark:text-grayScale-400">
            با نصب اپلیکیشن، به ترندی اسمارت از صفحه اصلی گوشی‌ات دسترسی داشته باش — بدون مرورگر، با
            اعلان‌های زنده.
          </p>

          <div className="mt-4 grid grid-cols-3 gap-2">
            {[
              { icon: Zap, label: "سرعت بیشتر" },
              { icon: Bell, label: "اعلان زنده" },
              { icon: WifiOff, label: "حالت آفلاین" },
            ].map((f, i) => (
              <div
                key={i}
                className="flex flex-col items-center gap-1 rounded-xl border border-grayScale-100 bg-grayScale-50 p-2.5 text-center dark:border-grayScale-700 dark:bg-grayScale-900/40"
              >
                <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary-100 text-primary-main dark:bg-primary-main/20">
                  <f.icon size={13} />
                </div>
                <span className="text-[10px] font-bold text-grayScale-700 dark:text-grayScale-300">
                  {f.label}
                </span>
              </div>
            ))}
          </div>

          <div className="mt-4 flex items-center gap-2">
            <button
              onClick={onInstall}
              className="group inline-flex flex-1 items-center justify-center gap-2 rounded-xl bg-primary-main px-4 py-2.5 text-xs font-bold text-white shadow-md shadow-primary-main/30 transition-all hover:scale-[1.02] hover:bg-primary-400"
            >
              <Download size={14} />
              نصب اپلیکیشن
            </button>
            <button
              onClick={onDismiss}
              className="rounded-xl border border-grayScale-200 px-4 py-2.5 text-xs font-bold text-grayScale-600 transition-colors hover:bg-grayScale-50 dark:border-grayScale-700 dark:text-grayScale-300 dark:hover:bg-grayScale-700/40"
            >
              بعداً
            </button>
          </div>

          <p className="mt-3 text-center text-[10px] text-grayScale-400">
            رایگان · بدون نیاز به فروشگاه اپ
          </p>
        </div>
      </div>
    </div>
  );
};

export default InstallPrompt;
